import { toggleAccordion } from "./horoscope.js"
import { prepareRangeHoroscopeContent } from "./horoscope.jsx"

export function setToggleAccordion(page) {
  const accordions = page.querySelectorAll(".accordion")
  const accordionBodies = page.querySelectorAll(".horoscope .accordion-body")
  const hasModalUsageExpired = page.querySelector("dialog#extend-usage")

  prepareRangeHoroscopeContent(accordionBodies)
  accordions.forEach((accordion) => {
    if (hasModalUsageExpired) { return }
    // หน้านี้ถูกตั้ง listener จากทั้ง turbo:load และ turbo:frame-load — ถ้าผูกซ้ำ
    // การ์ดจะกางแล้วยุบทันทีในคลิกเดียว (เหมือนกดอ่านไม่ได้) จึงผูกได้ใบละครั้งเดียว
    if (accordion.dataset.accordionBound === "1") { return }
    accordion.dataset.accordionBound = "1"
    toggleAccordion(accordion)
  })
}

document.addEventListener("turbo:load", function () {
  let page = document.getElementById("horoscope-range")
  if (page != null) {
    setToggleAccordion(page)
  }
})
